handleMissing